<shared-product-card
  [product]="productCard"
  [disableOverlay]="true"
></shared-product-card>
